
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular/lazy';
import type { OverlayEventDetail } from '@ionic/core';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonIcon,
  IonButton,
  IonButtons,
  IonItem,
  IonPopover,
  IonList,
  IonLabel,
  IonAvatar,
  IonAlert,
} from '@ionic/angular';
// import { ApiService } from '@app/services/api.service';
// import { ToasterService } from '@app/services/toaster.service';
// import { CustomTooltipComponent } from '../custom-tooltip/custom-tooltip.component';
// import { Store } from '@ngrx/store';
// import { Observable } from 'rxjs';
import { createAvatar } from '@app/utils/app.utils';
import { UserProfile } from '@app/types/app.types';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AuthService } from '@app/services/auth.service';
import { ModalGuardService } from '@app/services/modal-guard.service';
import { ConaTooltipComponent } from '../cona-tooltip/cona-tooltip.component';
import { FaqModalComponent } from '../faq-modal/faq-modal.component';
import { resolveFaqSectionFromUrl } from '@app/constants/faq.constants';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  standalone: true,
  imports: [
    IonContent,
    IonHeader,
    IonToolbar,
    IonButton,
    IonButtons,
    IonItem,
    IonPopover,
    IonList,
    IonLabel,
    IonAvatar,
    IonIcon,
    ConaTooltipComponent
],
  providers: [ModalController],
})
export class NavbarComponent implements AfterViewInit {
  profile$: Observable<UserProfile | null>;
  @ViewChild('avatarHolder') avatarHolder!: ElementRef<HTMLDivElement>;
  @ViewChild('avatarInnerHolder', { static: false })
  avatarInnerHolder!: ElementRef<HTMLDivElement>;

  constructor(
    private authService: AuthService,
    private store: Store,
    private router: Router,
    private modalGuardService: ModalGuardService,
  ) {
    this.profile$ = this.store.select((state: any) => {
      return state.app.profile;
    });
  }

  showPopover = false;
  userName = '';
  userEmail = '';
  userPhone = 'No Contact Provided';
  avatar: null | string = null;

  ngAfterViewInit(): void {
    this.profile$?.subscribe((profile: UserProfile | null) => {
      if (profile) {
        this.userName = profile.fullName;
        this.avatar = profile.avatar;
        this.userEmail = profile.emailAddress;
        if (!this.avatar) {
          const avatarInitials = createAvatar(this.userName);
          this.avatarHolder.nativeElement.appendChild(avatarInitials);
        }
      }
    });
  }

  togglePopover(event: Event) {
    this.showPopover = !this.showPopover;
    setTimeout(() => {
      if (this.avatarInnerHolder) {
        const avatarInitials = createAvatar(this.userName);
        avatarInitials.style.width = '68px';
        avatarInitials.style.height = '68px';
        avatarInitials.style.fontSize = '24px';
        this.avatarInnerHolder.nativeElement.appendChild(avatarInitials);
      } else {
        console.error('avatarInnerHolder is still undefined');
      }
    }, 100);
  }

  setResult(event: CustomEvent<OverlayEventDetail>) {
    console.log(`Dismissed with role: ${event.detail.role}`);
  }

  closePopover() {
    this.showPopover = false;
  }

  switchAccount() {
    // Handle account switch logic
    this.closePopover();
    console.log('switch the account');
  }

  logout() {
    // Handle logout logic
    this.authService.logout();
    this.closePopover();
  }

  profileMenu() {
    console.log('Opening Profile Menu');
  }

  supportMenu() {
    this.openFaqModal();
  }

  async openFaqModal() {
    const currentSection = resolveFaqSectionFromUrl(this.router.url);
    await this.modalGuardService.createAndPresentOnce('faq-modal', {
      component: FaqModalComponent,
      componentProps: {
        initialSectionId: currentSection,
      },
      cssClass: 'faq-modal-overlay',
      backdropDismiss: true,
      showBackdrop: true,
    });
  }
}
